import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { obtenerDescripcionesServiciosAdicionales, setDescripciones } from "../logic";
import { PaqueteDocumentacionEdit } from "./edit";
const EditModal = PaqueteDocumentacionEdit;
type Entity = models.PaqueteDocumentacion;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    idDireccionDestino: number | undefined;
    idSucursalDestino: number | undefined;
    readonly?: boolean;
    error?: kea.FieldError;
    puedeModificarRecoleccion: boolean;
    asignarSeguroDefault?: boolean;
    session: models.Session | null;
}

export interface BotonesDeps {
    onEdit: (x: Entity) => void;
    onBorrar: (x: Entity) => void;
    onDuplicar: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
function columnas(deps: BotonesDeps): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones([...kea.columnaBotonesDefault(deps),
    {
        onClick: deps.onDuplicar,
        iconClass: fa("copy"),
        tooltip: "Duplicar"
    }]);

    return [
        botones,
        { title: "Cantidad", cell: x => ({ data: x.Cantidad }) },
        { title: "Peso y volumen", cell: x => ({ data: undefined, view: () => <span style={{ whiteSpace: "nowrap" }} ><i className={fa("balance-scale", "fw")} />{x.Peso} kg <i className={fa("cube", "fw")} />{x.Alto}×{x.Largo}×{x.Ancho} cm</span> }) },
        { title: "Destino (cli)", cell: x => ({ data: x.NombreCliente }) },
        { title: "Destino (dir)", cell: x => ({ data: x.DescripcionDestino }) },
        { title: "Destino (suc)", cell: x => ({ data: x.NombreSucursal }) },
        { title: "Servicios adicionales", cell: x => ({ data: obtenerDescripcionesServiciosAdicionales(x.ServiciosAdicionales), view: kea.arrayCell() }) },
        { title: "Descripción", cell: x => ({ data: x.NombreDescripcionPaquete }) },
        { title: "Contenido", cell: x => ({ data: x.NombreContenidoPaquete }) },
        { title: "Observaciones", cell: x => ({ data: x.Observaciones }) },

    ];
}

/**
* Listado de PaqueteDocumentacion
*/
class PaqueteDocumentacionListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    private handleOnAgregar = async () => {
        var puedeModificarRecoleccion = this.props.puedeModificarRecoleccion;
        var asignarSeguroDefault = typeof this.props.asignarSeguroDefault === "undefined" ? false : this.props.asignarSeguroDefault;
        //Si no puede modificar checkbox de recolección a domicilio siempre debe de ser true
        const result = await this.modals.showModal(EditModal, 
        { asignarSeguroDefault: asignarSeguroDefault, puedeModificarRecoleccion: puedeModificarRecoleccion, session: this.props.session, BanderaEscribir:false, BanderaDesabilitado:false },
         { IdDireccionDestino: this.props.idDireccionDestino, 
            IdSucursalDestino: this.props.idSucursalDestino, 
            ServiciosAdicionales: { RecoleccionDomicilio: !puedeModificarRecoleccion, ValorDeclarado: asignarSeguroDefault ? 1000 : undefined },
         } as Entity);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        console.log(this.props);
        var asignarSeguroDefault = typeof this.props.asignarSeguroDefault === "undefined" ? false : this.props.asignarSeguroDefault;
        var puedeModificarRecoleccion = this.props.puedeModificarRecoleccion;
        const result = await this.modals.showModal(EditModal, { asignarSeguroDefault: asignarSeguroDefault, puedeModificarRecoleccion: puedeModificarRecoleccion, session:this.props.session, BanderaEscribir: false , BanderaDesabilitado:false }, item);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    private handleOnDuplicar = (x: Entity) => {
        this.props.onChange([... this.props.value, { ...x, Observaciones: "" }]);
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar, onDuplicar: this.handleOnDuplicar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <kea.Title titulo="Paquetes" size="h4" error={this.props.error} onAgregar={this.props.readonly ? undefined : this.handleOnAgregar} iconClass={fa("cubes", "fw")} />
                    </div>
                </div >

                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda={true} />
                {this.modals.component}
            </div >
        );
    }
}
export const PaqueteDocumentacionList = kea.mapProps(componentToRx(PaqueteDocumentacionListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/paquetes/list.tsx